import { schema } from 'normalizr';
import EntityName from '../enums/EntityName';

export const equipmentSchema = new schema.Entity(EntityName.Equipment);

export const deliveryZoneSchema = new schema.Entity(EntityName.DeliveryZone);

export const projectSettingsSchema = new schema.Entity(EntityName.BookingProjectSettings, {
  bookingProjectEquipment: [equipmentSchema],
  projectDeliveryZones: [deliveryZoneSchema]
});

export const SchemasByEntityName: { [key in EntityName]?: schema.Entity } = {
  [EntityName.Equipment]: equipmentSchema,
  [EntityName.DeliveryZone]: deliveryZoneSchema,
  [EntityName.BookingProjectSettings]: projectSettingsSchema
};
